(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juizs-carousel"] && !Shopify.designMode) return;
  try {
    
/* Carousel — geport uit concept juizs-scripts.js r29–100.
   Per instance geïnitialiseerd (data-juizs-carousel); visible counts
   concept-conform: <560:1 · <968:1.5 · <1100:2.3 · desktop:3.
   Golf 6b (01-10): twee modi, gekozen met dezelfde mediaquery als de CSS.
   · ≥ 900px: de transform-carrousel zoals hij was, plus: krijgt een kaart
     buiten beeld de focus (Tab), dan schuift de rij mee (focus nooit onzichtbaar).
   · < 900px: VEEGRIJ — de rij scrollt zelf (scroll-snap); de knoppen scrollen
     een kaart verder, de teller volgt de scrollpositie. Geen sleepcode. */
(function () {
  var SWIPE = window.matchMedia('(max-width: 899.98px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initCarousel(root) {
    var track = root.querySelector('[data-jcr-track]');
    if (!track || track.children.length === 0) return;
    var viewport = root.querySelector('.juizs-carousel-viewport-inner');
    var prevBtn = root.querySelector('[data-jcr-prev]');
    var nextBtn = root.querySelector('[data-jcr-next]');
    var currentEl = root.querySelector('[data-jcr-current]');
    var totalEl = root.querySelector('[data-jcr-total]');
    var cards = track.children;
    var index = 0;

    function swipe() { return SWIPE.matches && !!viewport; }
    function visibleCount() {
      if (window.innerWidth < 560) return 1;
      if (window.innerWidth < 968) return 1.5;
      if (window.innerWidth < 1100) return 2.3;
      return 3;
    }
    function maxIndex() {
      return Math.max(0, Math.ceil(cards.length - visibleCount()));
    }
    function step() {
      var gap = parseInt(getComputedStyle(track).gap, 10) || 24;
      return cards[0].offsetWidth + gap;
    }
    function scrollEnd() {
      return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    }
    function update() {
      if (swipe()) {
        track.style.transform = '';
        var x = viewport.scrollLeft;
        var i = Math.min(cards.length - 1, Math.round(x / step()));
        if (x >= scrollEnd() - 2) i = cards.length - 1;
        if (currentEl) currentEl.textContent = i + 1;
        if (prevBtn) prevBtn.disabled = x <= 2;
        if (nextBtn) nextBtn.disabled = x >= scrollEnd() - 2;
        return;
      }
      track.style.transition = '';
      track.style.transform = 'translateX(-' + index * step() + 'px)';
      if (currentEl) currentEl.textContent = Math.min(index + 1, cards.length);
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex();
    }
    function go(dir) {
      if (swipe()) {
        viewport.scrollBy({ left: dir * step(), behavior: REDUCED.matches ? 'auto' : 'smooth' });
        return;
      }
      index = Math.max(0, Math.min(maxIndex(), index + dir));
      update();
    }
    if (totalEl) totalEl.textContent = cards.length;
    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });
    window.addEventListener('resize', function () { index = Math.min(index, maxIndex()); update(); });

    /* Veegrij: teller en knoppen volgen de scrollpositie (rAF tijdens het
       vegen; de timeout en scrollend zorgen voor de eindstand, ook als rAF
       stilligt, bv. in een tabblad op de achtergrond) */
    var ticking = false, settle = null;
    if (viewport) {
      viewport.addEventListener('scroll', function () {
        if (!swipe()) return;
        clearTimeout(settle);
        settle = setTimeout(update, 120);
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });
      viewport.addEventListener('scrollend', function () { if (swipe()) update(); });
    }

    /* Modus wisselt (draaien, venster smaller/breder): schoon beginnen */
    function onModeChange() {
      index = 0;
      track.style.transform = '';
      if (viewport) viewport.scrollLeft = 0;
      update();
    }
    if (SWIPE.addEventListener) SWIPE.addEventListener('change', onModeChange);
    else if (SWIPE.addListener) SWIPE.addListener(onModeChange);

    /* Desktop: focus op een kaart buiten beeld → rij schuift mee */
    track.addEventListener('focusin', function (e) {
      if (swipe()) return;
      /* alleen toetsenbordfocus: een muisklik op de piek-kaart mag de rij niet verschuiven */
      try { if (!e.target.matches(':focus-visible')) return; } catch (err) {}
      var card = e.target.closest('.juizs-carousel-card');
      if (!card) return;
      var i = Array.prototype.indexOf.call(cards, card);
      var fit = Math.max(1, Math.floor(visibleCount()));
      if (i < index) index = i;
      else if (i > index + fit - 1) index = Math.min(maxIndex(), i - fit + 1);
      else return;
      update();
    });

    /* touch/drag — concept setupDrag, vereenvoudigd; alleen in de desktopmodus */
    var startX = 0, down = false;
    function onDown(e) {
      if (swipe()) return;
      down = true;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      track.style.transition = 'none';
    }
    function onMove(e) {
      if (!down) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      track.style.transform = 'translateX(' + (-index * step() + (x - startX)) + 'px)';
    }
    function onUp(e) {
      if (!down) return;
      down = false;
      var x = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
      var delta = x - startX;
      if (delta < -50) index = Math.min(maxIndex(), index + 1);
      if (delta > 50) index = Math.max(0, index - 1);
      update();
    }
    track.addEventListener('mousedown', onDown);
    track.addEventListener('touchstart', onDown, { passive: true });
    window.addEventListener('mousemove', onMove);
    track.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('mouseup', onUp);
    track.addEventListener('touchend', onUp);

    update();
  }
  document.querySelectorAll('[data-juizs-carousel]').forEach(initCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juizs-compare"] && !Shopify.designMode) return;
  try {
    
/* juizs-compare — golf 6a: hint + toetsenbord alleen als de tabel scrolt.
   Scrolt hij (mobiel), dan krijgt de scrollstrook tabindex=0, role=region en de
   sectiekop als naam (WCAG 2.1.1: een scrollbaar gebied zonder focusbare inhoud
   moet met het toetsenbord bereikbaar zijn). Past hij, dan geen extra tabstop. */
(function () {
  function initScroll(sc) {
    if (sc.dataset.jcmInit === 'true') return;
    sc.dataset.jcmInit = 'true';
    var hint = document.getElementById(sc.getAttribute('data-jcm-hint-id'));
    var labelId = sc.getAttribute('data-jcm-label-id');
    function update() {
      var scrollable = getComputedStyle(sc).overflowX !== 'visible' && sc.scrollWidth > sc.clientWidth + 1;
      if (hint) hint.hidden = !scrollable;
      if (scrollable) {
        sc.setAttribute('tabindex', '0');
        sc.setAttribute('role', 'region');
        if (labelId) sc.setAttribute('aria-labelledby', labelId);
        if (hint) sc.setAttribute('aria-describedby', hint.id);
      } else {
        sc.removeAttribute('tabindex');
        sc.removeAttribute('role');
        sc.removeAttribute('aria-labelledby');
        sc.removeAttribute('aria-describedby');
      }
    }
    update();
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(sc);
    else window.addEventListener('resize', update);
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-jcm-scroll]').forEach(initScroll); }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juizs-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Na verzenden herlaadt Shopify de pagina. Geef de melding (gelukt of fout)
    // focus, zodat een schermlezer hem voorleest en toetsenbordgebruikers
    // vanaf daar verder kunnen — patroon van de GOV.UK-foutsamenvatting.
    function focusFeedback() {
      var el = document.querySelector('[data-juizs-cnt-feedback]');
      if (el) el.focus();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', focusFeedback);
    } else {
      focusFeedback();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juizs-explainer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('[data-jex-track]');
    var nav = root.querySelector('[data-jex-nav]');
    if (!track || !nav) return;
    if (root.hasAttribute('data-jex-ready')) return;
    root.setAttribute('data-jex-ready', '');

    var prev = nav.querySelector('[data-jex-prev]');
    var next = nav.querySelector('[data-jex-next]');

    // De pijlen doen alleen iets mét JS, dus verschijnen ook alleen dan.
    nav.hidden = false;

    function step() {
      // Eén paneel is precies de breedte van de track (grid-auto-columns 100%).
      return track.clientWidth;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      // 2px marge: browsers ronden scrollLeft af op subpixels.
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-juizs-explainer]');
    Array.prototype.forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  // Theme-editor: na een sectiewijziging is de DOM vervangen.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juizs-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  const header = document.querySelector('[data-juizs-header]');
  if (!header) return;

  const toggle = header.querySelector('[data-juizs-header-toggle]');
  // Drawer is sibling van <header>, dus query vanuit document
  const drawer = document.querySelector('[data-juizs-header-drawer]');
  const closeBtn = drawer ? drawer.querySelector('[data-juizs-header-close]') : null;

  /* Overlay-contract (Prism FIX-001 t/m FIX-003, 2026-07-13) — geldt voor ELKE
     toekomstige overlay op deze site:
       1. dicht = inert + aria-hidden="true"; open = beide eraf
       2. openen  -> focus naar de close-knop
       3. sluiten -> focus terug naar de trigger die hem opende
       4. Escape sluit; Tab blijft binnen de overlay zolang hij open is
       5. de trigger draagt aria-expanded                                     */
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), ' +
                    'select, textarea, [tabindex]:not([tabindex="-1"])';

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    // Focus naar binnen, anders staat de gebruiker nog achter de overlay
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    // inert pas ná het verplaatsen van de focus: focus() op een inert element
    // wordt genegeerd, en dan valt de focus terug naar <body> — de gebruiker
    // is dan zijn plek op de pagina kwijt.
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
    drawer.setAttribute('inert', '');
    document.body.style.overflow = '';
  }

  // Focus-trap: Tab mag de open drawer niet verlaten
  if (drawer) {
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      const items = Array.from(drawer.querySelectorAll(FOCUSABLE))
        .filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  if (toggle) toggle.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  // Sluit op Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Sluit drawer wanneer een link erbinnen wordt gevolgd
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') closeDrawer();
    });
  }

  // Hide-on-scroll-down, show-on-scroll-up — alleen als sticky enabled
  const isSticky = header.classList.contains('juizs-header--sticky');
  if (isSticky) {
    let lastScroll = 0;
    let ticking = false;
    const SCROLL_THRESHOLD = 100;

    function updateScrollState() {
      const currentScroll = window.pageYOffset;

      if (currentScroll > SCROLL_THRESHOLD) {
        if (currentScroll > lastScroll) {
          header.classList.add('juizs-header--hidden');
        } else if (currentScroll < lastScroll) {
          header.classList.remove('juizs-header--hidden');
        }
      } else {
        header.classList.remove('juizs-header--hidden');
      }

      lastScroll = currentScroll;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollState);
        ticking = true;
      }
    }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juizs-page-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function slug(t, i) {
      var s = (t || '').toLowerCase();
      if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
      s = s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      return s ? s : 'sectie-' + i;
    }

    function build(root) {
      var article = root.querySelector('[data-jpc-article]');
      var desktop = root.querySelector('.juizs-pgc-toc');
      var mobile = root.querySelector('.juizs-pgc-toc-mobile');
      if (!article || !desktop) return;

      var list = desktop.querySelector('[data-jpc-toc-list]');
      var listM = mobile ? mobile.querySelector('[data-jpc-toc-list-mobile]') : null;
      var heads = article.querySelectorAll('h2');

      list.innerHTML = '';
      if (listM) listM.innerHTML = '';

      // Minder dan 2 koppen: een inhoudsopgave voegt niets toe.
      if (heads.length < 2) {
        desktop.hidden = true;
        if (mobile) { mobile.hidden = true; mobile.removeAttribute('data-jpc-ready'); }
        root.classList.remove('juizs-pgc-section--toc');
        return;
      }

      root.classList.add('juizs-pgc-section--toc');
      Array.prototype.forEach.call(heads, function (h, i) {
        if (!h.id) h.id = slug(h.textContent, i);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        list.appendChild(li);
        if (listM) listM.appendChild(li.cloneNode(true));
      });

      desktop.hidden = false;
      if (mobile) { mobile.hidden = false; mobile.setAttribute('data-jpc-ready', ''); }
    }

    function init() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-juizs-pgc-toc]'), build);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // Theme-editor: sectie opnieuw opbouwen na een wijziging.
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-juizs-pgc-toc]');
      if (root) build(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juizs-product-details"] && !Shopify.designMode) return;
  try {
    
/* juizs-product-details — hoofdtabs (tablist + pijltjes) en dag-filter.
   D0b: deze laag hoort bij de audit-scope. Per sectie geïnitialiseerd. */
(function () {
  function initPdt(root) {
    if (root.dataset.pdtInit === 'true') return;
    root.dataset.pdtInit = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.juizs-pdt-tab'));
    var panes = Array.prototype.slice.call(root.querySelectorAll('.juizs-pdt-pane'));

    function selectTab(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panes.forEach(function (p) {
        p.hidden = p.dataset.pdtPane !== tab.dataset.pdtTab;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectTab(t); });
      t.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var next = tabs[(i + dir + tabs.length) % tabs.length];
        selectTab(next);
        next.focus();
      });
    });

    /* Golf 6a: accordeon onder 700px. Zelfde panelen; per breedte wisselen hun
       rol en label (tabpanel + tab ↔ region + knop). Bij de wissel blijft open
       wat open was: het gekozen tabje wordt het open paneel, en terug. */
    var accs = Array.prototype.slice.call(root.querySelectorAll('[data-pdt-acc]'));
    var accMq = window.matchMedia ? window.matchMedia('(max-width: 700px)') : null;
    var mode = null;
    function paneFor(key) { return root.querySelector('[data-pdt-pane="' + key + '"]'); }
    function toAccordion() {
      var sel = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
      var selKey = sel ? sel.getAttribute('data-pdt-tab') : null;
      accs.forEach(function (a) {
        var key = a.getAttribute('data-pdt-acc'), pane = paneFor(key), open = key === selKey;
        a.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!pane) return;
        pane.hidden = !open;
        pane.setAttribute('role', 'region');
        pane.setAttribute('aria-labelledby', a.id);
      });
    }
    function toTabs() {
      var openAcc = accs.filter(function (a) { return a.getAttribute('aria-expanded') === 'true'; })[0];
      var key = openAcc ? openAcc.getAttribute('data-pdt-acc') : null;
      panes.forEach(function (p) {
        var t = root.querySelector('[data-pdt-tab="' + p.getAttribute('data-pdt-pane') + '"]');
        p.setAttribute('role', 'tabpanel');
        if (t) p.setAttribute('aria-labelledby', t.id);
      });
      var tab = tabs.filter(function (t) { return t.getAttribute('data-pdt-tab') === key; })[0] || tabs[0];
      if (tab) selectTab(tab);
    }
    function applyMode() {
      var next = accMq && accMq.matches && accs.length ? 'acc' : 'tabs';
      if (next === mode) return;
      var prev = mode;
      mode = next;
      if (next === 'acc') toAccordion();
      else if (prev === 'acc') toTabs();
    }
    accs.forEach(function (a) {
      a.addEventListener('click', function () {
        var pane = paneFor(a.getAttribute('data-pdt-acc'));
        var open = a.getAttribute('aria-expanded') === 'true';
        a.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (pane) pane.hidden = open;
      });
    });
    applyMode();
    if (accMq) {
      if (accMq.addEventListener) accMq.addEventListener('change', applyMode);
      else if (accMq.addListener) accMq.addListener(applyMode);
    }

    /* Dag-filter (legacy block-modus): till-dinner verbergt all-day-only momenten */
    var dayTabs = Array.prototype.slice.call(root.querySelectorAll('.juizs-pdt-day-tab[data-pdt-day]'));
    var onlyAllDay = Array.prototype.slice.call(root.querySelectorAll('[data-only="all-day"]'));
    dayTabs.forEach(function (d) {
      d.addEventListener('click', function () {
        dayTabs.forEach(function (x) { x.setAttribute('aria-pressed', x === d ? 'true' : 'false'); });
        var hide = d.dataset.pdtDay === 'till-dinner';
        onlyAllDay.forEach(function (m) { m.hidden = hide; });
      });
    });

    /* C3 (17-07): variant-sync — day-tabs = variant-switcher (metafield-modus);
       luistert op juizs:variant-change uit de buy-box (één richting) en leest
       bij init de buy-box-staat uit [data-jph-variant-id] (script-volgorde-proof). */
    var vTabs = Array.prototype.slice.call(root.querySelectorAll('[data-jpd-variant-tab]'));
    var vGroups = Array.prototype.slice.call(root.querySelectorAll('[data-jpd-schema]'));
    function showVariant(id) {
      id = String(id);
      var known = vGroups.some(function (g) { return g.getAttribute('data-jpd-schema') === id; });
      if (!known) return;
      vGroups.forEach(function (g) { g.hidden = g.getAttribute('data-jpd-schema') !== id; });
      vTabs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-jpd-variant-tab') === id ? 'true' : 'false'); });
    }
    vTabs.forEach(function (t) {
      t.addEventListener('click', function () { showVariant(t.getAttribute('data-jpd-variant-tab')); });
    });
    if (vGroups.length) {
      document.addEventListener('juizs:variant-change', function (e) {
        if (e.detail && e.detail.variantId) showVariant(e.detail.variantId);
      });
      var buyInput = document.querySelector('[data-jph-variant-id]');
      if (buyInput && buyInput.value) showVariant(buyInput.value);
    }
  }
  function initAll() {
    document.querySelectorAll('[data-juizs-pdt]').forEach(initPdt);
  }
  initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-juizs-pdt]');
    if (root) { root.dataset.pdtInit = ''; initPdt(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juizs-product-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    if (!root || root.dataset.jphInit === 'true') return;
    root.dataset.jphInit = 'true';

    var pricingEl = root.querySelector('[data-jph-pricing]');
    var pricing = {};
    try { pricing = JSON.parse(pricingEl.textContent).variants || {}; } catch (e) { pricing = {}; }

    var variantInput = root.querySelector('[data-jph-variant-id]');
    var planInput = root.querySelector('[data-jph-plan-id]');
    var priceMain = root.querySelector('[data-jph-price-main]');
    var kopPrice = root.querySelector('[data-jph-kop-price]');
    var priceWas = root.querySelector('[data-jph-price-was]');
    var priceMeta = root.querySelector('[data-jph-price-meta]');
    var ctaChip = root.querySelector('[data-jph-cta-chip]');
    var qtyVal = root.querySelector('[data-jph-qty-val]');
    var deferred = root.querySelector('[data-jph-deferred]');
    var submitBtn = root.querySelector('[data-jph-submit]');
    var ctaText = root.querySelector('.juizs-jph-cta-text');
    var ctaLabel = ctaText ? ctaText.textContent : '';

    // State: {variant, tab, plan} — plan blijft behouden bij variant-wissel (Seal reset-fix)
    var state = {
      variantId: variantInput ? variantInput.value : null,
      tab: (root.querySelector('[data-jph-default-tab]') || {}).dataset ? (root.querySelector('[data-jph-default-tab]').dataset.jphDefaultTab || 'once') : 'once',
      planByTab: { reeks: null, abo: null },
      reeksCount: 1
    };

    function money(cents) {
      if (cents == null) return '';
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
    /* Zonder stepper staat er een hidden input met 1 — qty() valt dan terug op 1. */
    function qty() { var q = parseInt(qtyVal && qtyVal.value, 10); return isNaN(q) ? 1 : Math.min(9, Math.max(1, q)); }

    function currentPlanId() {
      if (state.tab === 'once') return null;
      return state.planByTab[state.tab] || null;
    }

    function priceFor(variantId, planId) {
      var v = pricing[variantId];
      if (!v) return { price: 0, compareAt: 0, perDelivery: 0 };
      if (!planId) return { price: v.price, compareAt: v.compareAt, perDelivery: v.price };
      var p = v.plans && v.plans[planId];
      return p ? { price: p.price, compareAt: p.compareAt, perDelivery: p.perDelivery } : { price: v.price, compareAt: v.compareAt, perDelivery: v.price };
    }
    function basePrice(variantId) { var v = pricing[variantId]; return v ? v.price : 0; }

    function render() {
      var planId = currentPlanId();
      var info = priceFor(state.variantId, planId);
      var isReeks = state.tab === 'reeks';
      var base = basePrice(state.variantId);

      // Hidden inputs (form-serialisatie): id + selling_plan
      if (variantInput) variantInput.value = state.variantId || '';
      if (planInput) planInput.value = planId || '';

      // Hoofdprijs: reeks = per kuur (per_delivery_price); anders = allocation.price
      var mainC = isReeks ? (info.perDelivery || info.price) : info.price;
      var wasC = isReeks ? base : info.compareAt;
      var hasDiscount = wasC && wasC > mainC;
      if (priceMain) { priceMain.textContent = money(mainC); priceMain.classList.toggle('is-discount', !!hasDiscount); }
      // Golf 6a: de prijsregel in de kop (mobiel) neemt de tekst van [data-jph-price-main]
      // over — dezelfde bron, geen tweede berekening.
      if (kopPrice && priceMain) { kopPrice.textContent = priceMain.textContent; kopPrice.classList.toggle('is-discount', priceMain.classList.contains('is-discount')); }
      // Golf 6a: prijs per pakket op de variantkaarten (alleen zichtbaar onder 900px),
      // met hetzelfde plan en dezelfde priceFor als de hoofdprijs.
      root.querySelectorAll('[data-jph-variant-price]').forEach(function (el) {
        var vi = priceFor(el.getAttribute('data-jph-variant-price'), planId);
        el.textContent = money(isReeks ? (vi.perDelivery || vi.price) : vi.price);
      });
      if (priceWas) {
        if (hasDiscount) { priceWas.textContent = money(wasC); priceWas.hidden = false; }
        else { priceWas.hidden = true; }
      }

      // CTA-chip = wat je nu betaalt. Reeks = allocation.price: sinds de Seal-fix (OD-013, 17-07)
      // is dat het volledige vooruitbetaalbedrag — per definitie gelijk aan de checkout-afschrijving.
      // Aantal bezorgingen afgeleid uit allocation ÷ per-kuur (robuust tegen groepsnaam-wijzigingen).
      var perKuur = info.perDelivery || info.price;
      var reeksN = state.reeksCount || 1;
      if (isReeks && perKuur > 0) {
        var derivedN = Math.round(info.price / perKuur);
        if (derivedN > 0) reeksN = derivedN;
      }
      // 29-07: `info.price` is bij ALLE drie de koopvormen de prijs per stuk —
      // bij een reeks het volledige vooruitbetaalbedrag per kuur, bij een abo de
      // prijs per bezorging. Het aantal hoort er dus altijd overheen (OD-028).
      // De prepaid-toelichting blijft ongemoeid: die rekent met per_delivery_price.
      var payNow = info.price * qty();
      if (ctaChip) ctaChip.textContent = money(payNow);

      // C1a: uitverkochte variant → CTA blokkeert (radio's blijven bedienbaar)
      var vData = pricing[state.variantId];
      var vAvail = !vData || vData.available !== false;
      if (submitBtn) submitBtn.disabled = !vAvail;
      if (ctaText) ctaText.textContent = vAvail ? ctaLabel : 'Uitverkocht';

      // Abo-kaartprijzen (per bezorging)
      root.querySelectorAll('[data-jph-plan-price]').forEach(function (el) {
        el.textContent = money(priceFor(state.variantId, el.getAttribute('data-jph-plan-price')).price);
      });
      // Abo p.m.-prijs (concept rich-meta): alleen bij een maandplan; onbekende cadence → geen p.m.
      root.querySelectorAll('[data-jph-plan-pm]').forEach(function (el) {
        var id = el.getAttribute('data-jph-plan-pm');
        var cad = root.querySelector('[data-jph-plan-cadence="' + id + '"]');
        var txt = cad ? cad.textContent.toLowerCase() : '';
        // Kwartaal (3 maanden): géén p.m. — wekt doorlopende-maandkosten-suggestie (Terry 17-07)
        // Weekplannen ook niet (24-09): 4 weken ≠ een maand (13 bezorgingen per jaar),
        // dus "€X p.m." stelde de maandkosten ~8% te laag voor; 2 weken ×2 idem.
        var mult = 0;
        if (txt.indexOf('3 maand') > -1 || txt.indexOf('kwart') > -1) mult = 0;
        else if (txt.indexOf('maand') > -1) mult = 1;
        if (mult) { el.textContent = '\u00b7 ' + money(priceFor(state.variantId, id).price * mult) + ' p.m.'; el.hidden = false; }
        else { el.hidden = true; }
      });
      // Abo-kortingsbadges
      root.querySelectorAll('[data-jph-plan-badge]').forEach(function (el) {
        var pi = priceFor(state.variantId, el.getAttribute('data-jph-plan-badge'));
        if (pi.compareAt && pi.compareAt > pi.price) { el.textContent = '−' + Math.round((1 - pi.price / pi.compareAt) * 100) + '%'; el.hidden = false; }
        else { el.hidden = true; }
      });
      // Reeks groep-prijzen (per kuur, variant-afhankelijk) + kortingsbadge
      root.querySelectorAll('[data-reeks-group-price]').forEach(function (el) {
        var pi = priceFor(state.variantId, el.getAttribute('data-reeks-firstplan'));
        el.textContent = money(pi.perDelivery || pi.price);
      });
      root.querySelectorAll('[data-reeks-badge]').forEach(function (el) {
        var card = el.closest('[data-reeks-group]');
        var fp = card && card.querySelector('[data-reeks-firstplan]');
        var pi = fp ? priceFor(state.variantId, fp.getAttribute('data-reeks-firstplan')) : null;
        var pk = pi ? (pi.perDelivery || pi.price) : 0;
        if (pi && base && pk < base) { el.textContent = '−' + Math.round((1 - pk / base) * 100) + '%'; el.hidden = false; }
        else { el.hidden = true; }
      });

      // Deferred disclaimer alleen bij plan-tabs (Seal-verplicht)
      if (deferred) deferred.hidden = (state.tab === 'once');

      // Meta-regel
      if (priceMeta) {
        if (state.tab === 'once') priceMeta.textContent = 'Eenmalig';
        else if (isReeks) priceMeta.textContent = 'Totaal ' + money(payNow) + ' · ' + reeksN + '× bezorging · stopt automatisch';
        else priceMeta.textContent = 'Abonnement · per levering'; // 01-10: "levering" (kernformule looptijd)
      }
    }

    // Variant-radiogroup
    root.querySelectorAll('[data-jph-variant] input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        state.variantId = radio.value;
        root.querySelectorAll('[data-jph-variant]').forEach(function (card) {
          card.classList.toggle('is-selected', card.contains(radio) && radio.checked);
        });
        render(); // behoudt tab + plan
        // C3 (17-07): details/modal schakelen live mee
        document.dispatchEvent(new CustomEvent('juizs:variant-change', { detail: { variantId: radio.value } }));
      });
    });

    // Plan-radiogroups
    root.querySelectorAll('.juizs-jph-plan input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var panel = radio.closest('[data-jph-panel]');
        var tab = panel ? panel.getAttribute('data-jph-panel') : null;
        if (tab) state.planByTab[tab] = radio.value;
        var wrap = radio.closest('[data-jph-panel]');
        if (wrap) wrap.querySelectorAll('.juizs-jph-plan').forEach(function (c) { c.classList.toggle('is-selected', c.contains(radio) && radio.checked); });
        render();
      });
    });
    // Init planByTab defaults uit de gecheckte radios
    root.querySelectorAll('[data-jph-panel]').forEach(function (panel) {
      var tab = panel.getAttribute('data-jph-panel');
      var checked = panel.querySelector('input[type="radio"]:checked');
      if (tab !== 'once' && checked) state.planByTab[tab] = checked.value;
    });

    // Commit-tablist (tab-wissel kiest eerste/behouden plan van die tab)
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-jph-tab]'));
    function activateTab(tab, focusIt) {
      state.tab = tab;
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-jph-tab') === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focusIt) t.focus();
      });
      root.querySelectorAll('[data-jph-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-jph-panel') !== tab;
        panel.classList.toggle('is-active', panel.getAttribute('data-jph-panel') === tab);
      });
      render();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activateTab(t.getAttribute('data-jph-tab'), false); });
      t.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        // Golf 7a: één tab (Eenmalig zonder plannen) → pijltjes doen niets
        if (!dir || tabs.length < 2) return;
        e.preventDefault();
        var next = (i + dir + tabs.length) % tabs.length;
        activateTab(tabs[next].getAttribute('data-jph-tab'), true);
      });
    });

    // Add-on-limiet (bouwplan B §3.6): bij het maximum de rest uitschakelen.
    var addonWrap = root.querySelector('[data-jph-addon]');
    var addonMax = addonWrap ? parseInt(addonWrap.getAttribute('data-jph-addon-max'), 10) : 0;
    if (addonWrap && addonMax > 0) {
      var addonBoxes = Array.prototype.slice.call(addonWrap.querySelectorAll('[data-jph-addon-variant]'));
      var addonCounter = addonWrap.querySelector('[data-jph-addon-count]');
      var enforceAddonMax = function () {
        var gekozen = addonBoxes.filter(function (c) { return c.checked; }).length;
        addonBoxes.forEach(function (c) {
          /* Een uitverkochte add-on blijft uitgeschakeld; die niet per ongeluk aanzetten. */
          if (c.dataset.soldout === 'true') return;
          c.disabled = !c.checked && gekozen >= addonMax;
          c.closest('.juizs-jph-addon-row').classList.toggle('is-disabled', c.disabled);
        });
        if (addonCounter) addonCounter.textContent = gekozen + ' van ' + addonMax + ' gekozen';
      };
      addonBoxes.forEach(function (c) { c.addEventListener('change', enforceAddonMax); });
      enforceAddonMax();
    }

    // Add-on disclosure
    var addonToggle = root.querySelector('[data-jph-addon-toggle]');
    if (addonToggle) {
      var panel = root.querySelector('#' + addonToggle.getAttribute('aria-controls'));
      addonToggle.addEventListener('click', function () {
        var open = addonToggle.getAttribute('aria-expanded') === 'true';
        addonToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.hidden = open;
      });
    }

    // ---- Golf 7a: omschrijving/tekst ingekort met "Lees meer" (snippet juizs-product-description) ----
    // De CSS kort al in op N regels (geen verspringing bij het laden). Hier: meten of de
    // tekst echt langer is dan N regels. Zo niet → is-fits (volledig, geen knop). Zo wel →
    // de grens precies tussen regel N en N+1 (alinea-marges en lijsten tellen mee), anders
    // de terugval N × line-height. Opnieuw meten als de breedte wijzigt of de fonts binnen zijn.
    root.querySelectorAll('[data-jph-desc-clamp]').forEach(function (wrap) {
      var body = wrap.querySelector('[data-jph-desc-body]');
      var btn = wrap.querySelector('[data-jph-desc-toggle]');
      if (!body || !btn) return;
      var label = btn.querySelector('[data-jph-desc-label]');
      var lines = parseInt(wrap.style.getPropertyValue('--jph-desc-lines'), 10) || 4;
      function rows() {
        // Regels = de regelvakken van alle tekst; tekst op dezelfde regel (strong, link) samen
        var top = body.getBoundingClientRect().top;
        var out = [];
        var range = document.createRange();
        var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null);
        var node;
        while ((node = walker.nextNode())) {
          if (!node.nodeValue.trim()) continue;
          range.selectNodeContents(node);
          Array.prototype.forEach.call(range.getClientRects(), function (r) {
            if (r.width < 1 || r.height < 1) return;
            var last = out[out.length - 1];
            var t = r.top - top, b = r.bottom - top;
            if (last && t < last.bottom - 1 && b > last.top + 1) { last.top = Math.min(last.top, t); last.bottom = Math.max(last.bottom, b); }
            else out.push({ top: t, bottom: b });
          });
        }
        return out;
      }
      function measure() {
        var list = rows();
        var fits, cut = 0;
        if (list.length) {
          fits = list.length <= lines;
          // Halverwege de ruimte tussen regel N en N+1: geen halve regel zichtbaar
          if (!fits) cut = Math.ceil((list[lines - 1].bottom + list[lines].top) / 2);
        } else {
          var lh = parseFloat(window.getComputedStyle(body).lineHeight) || 24;
          fits = body.scrollHeight <= lines * lh + 2;
          cut = Math.round(lines * lh);
        }
        wrap.classList.toggle('is-fits', fits);
        btn.hidden = fits;
        if (cut) body.style.setProperty('--jph-desc-max', cut + 'px');
      }
      function setOpen(open) {
        var before = btn.getBoundingClientRect().top;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        wrap.classList.toggle('is-open', open);
        if (label) label.textContent = open ? btn.getAttribute('data-label-less') : btn.getAttribute('data-label-more');
        // Inklappen van een lange tekst: valt de knop (met de focus) boven uit beeld, dan
        // terug naar waar hij stond. Chrome/Firefox houden hem zelf op zijn plek
        // (scroll-anchoring), Safari niet; alleen corrigeren als hij echt uit beeld is.
        if (!open) {
          var r = btn.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) window.scrollBy(0, r.top - before);
        }
      }
      btn.addEventListener('click', function () { setOpen(btn.getAttribute('aria-expanded') !== 'true'); });
      // Een link in het ingekorte deel krijgt focus → uitklappen, anders staat de focus onzichtbaar
      body.addEventListener('focusin', function () {
        if (!wrap.classList.contains('is-fits') && btn.getAttribute('aria-expanded') !== 'true') setOpen(true);
      });
      measure();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      if ('ResizeObserver' in window) {
        var lastW = wrap.clientWidth;
        new ResizeObserver(function () {
          if (wrap.clientWidth === lastW) return;
          lastW = wrap.clientWidth;
          measure();
        }).observe(wrap);
      }
    });

    // Qty-stepper
    var down = root.querySelector('[data-jph-qty-down]');
    var up = root.querySelector('[data-jph-qty-up]');
    if (down) down.addEventListener('click', function () { qtyVal.value = Math.max(1, qty() - 1); render(); });
    if (up) up.addEventListener('click', function () { qtyVal.value = Math.min(9, qty() + 1); render(); });
    if (qtyVal) qtyVal.addEventListener('change', function () { qtyVal.value = qty(); render(); });

    // Add-ons (fine-tune 17-07): mét aangevinkte add-ons neemt de knop de aankoop
    // volledig over — hoofdproduct + add-ons in ÉÉN atomaire /cart/add.js, daarna naar
    // de cart-pagina zodat het totaal (kuur + shots) altijd klopt. Zonder add-ons blijft
    // de normale Dawn-flow (drawer) ongewijzigd.
    var jphForm = root.querySelector('.juizs-jph-form');
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    if (submitBtn && jphForm) {
      submitBtn.addEventListener('click', function (e) {
        var checked = Array.prototype.slice.call(root.querySelectorAll('.juizs-jph-addon-check:checked')).filter(function (c) { return !c.disabled; });
        if (!checked.length || submitBtn.dataset.jphAddonsBusy === '1') return;
        e.preventDefault();
        submitBtn.dataset.jphAddonsBusy = '1';
        submitBtn.classList.add('is-loading');
        var mainItem = { id: parseInt(state.variantId, 10), quantity: qty() };
        var planId = currentPlanId();
        if (planId) mainItem.selling_plan = parseInt(planId, 10);
        var items = [mainItem].concat(checked.map(function (c) {
          return { id: parseInt(c.getAttribute('data-jph-addon-variant'), 10), quantity: 1 };
        }));
        // OD-015: sinds de winkelwagen-lade bestaat gaat deze atomaire
        // multi-regel-toevoeging via window.JuizsCart.addItems — die zet
        // dezelfde ene /cart/add.js weg, ververst de lade en opent hem.
        // Zonder die laag (JS nog niet geladen) blijft de oude route naar
        // de cart-pagina staan, zodat het totaal altijd klopt.
        var addPromise = window.JuizsCart && window.JuizsCart.addItems
          ? window.JuizsCart.addItems(items, submitBtn).then(function () {
              submitBtn.dataset.jphAddonsBusy = '';
              submitBtn.classList.remove('is-loading');
            })
          : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
              .then(function (r) {
                if (!r.ok) throw new Error('add failed');
                window.location.href = cartUrl;
              });

        addPromise
          .catch(function () {
            // Val terug op de normale product-submit zodat de kuur sowieso in de mand komt
            submitBtn.dataset.jphAddonsBusy = '';
            submitBtn.classList.remove('is-loading');
            if (jphForm.requestSubmit) jphForm.requestSubmit(submitBtn); else jphForm.submit();
          });
      });
    }

    // ---- Gallery: thumbnails → slide-wissel (desktop: cross-fade via CSS) ----
    // Golf 6a: onder 900px is de stage een veegbaar spoor (scroll-snap). Vegen zet
    // het tabje mee en meldt "Beeld 2 van 3"; een tabje (klik of pijltjes) scrolt
    // het spoor naar zijn beeld. De teller telt alleen zichtbare tabjes (een
    // Stamped-reviewtabje is verborgen tot de review er staat).
    var jGallery = root.querySelector('[data-jph-gallery]');
    var jTrack = root.querySelector('[data-jph-track]');
    var jCounter = root.querySelector('[data-jph-counter]');
    var jCounterCur = root.querySelector('[data-jph-counter-cur]');
    var jCounterTotal = root.querySelector('[data-jph-counter-total]');
    var jStatus = root.querySelector('[data-jph-gallery-status]');
    var jThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-jph-thumb]'));
    var jPanes = Array.prototype.slice.call(root.querySelectorAll('[data-jph-pane]'));
    var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
    var activeSlide = '0';
    // Tijdens een eigen scroll (tabje → beeld) negeert de veeg-detectie de beelden
    // die voorbijkomen; het slot gaat eraf zodra het spoor 160ms stilstaat.
    var ownScroll = false;
    var ownScrollIdle = null;
    function releaseSoon() {
      clearTimeout(ownScrollIdle);
      ownScrollIdle = setTimeout(function () { ownScroll = false; }, 160);
    }
    if (jTrack) jTrack.addEventListener('scroll', function () { if (ownScroll) releaseSoon(); }, { passive: true });
    jPanes.forEach(function (pane) { pane.hidden = false; });
    function shownThumbs() { return jThumbs.filter(function (t) { return !t.hidden; }); }
    function isTrack() { return !!jTrack && jTrack.scrollWidth > jTrack.clientWidth + 1; }
    function syncCounter() {
      var list = shownThumbs();
      var pos = list.map(function (t) { return t.getAttribute('data-jph-thumb'); }).indexOf(activeSlide);
      if (jGallery) jGallery.setAttribute('data-jph-slides', String(list.length));
      if (jCounter) jCounter.hidden = list.length < 2;
      if (jCounterCur) jCounterCur.textContent = String(pos + 1);
      if (jCounterTotal) jCounterTotal.textContent = String(list.length);
      return { pos: pos, total: list.length };
    }
    function scrollToSlide(idx, smooth) {
      var pane = root.querySelector('[data-jph-pane="' + idx + '"]');
      if (!pane || !isTrack()) return;
      var anim = smooth && !reduceMotion;
      ownScroll = true;
      releaseSoon();
      jTrack.scrollTo({ left: pane.offsetLeft, behavior: anim ? 'smooth' : 'auto' });
    }
    function showSlide(idx, focusIt, source) {
      activeSlide = idx;
      jThumbs.forEach(function (t) { var on = t.getAttribute('data-jph-thumb') === idx; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; if (on && focusIt) t.focus(); });
      jPanes.forEach(function (pane) {
        var on = pane.getAttribute('data-jph-pane') === idx;
        pane.classList.toggle('is-active', on);
        // Alleen het actieve beeld voor schermlezers: op mobiel staan alle beelden in het spoor
        if (on) pane.removeAttribute('aria-hidden'); else pane.setAttribute('aria-hidden', 'true');
      });
      var at = syncCounter();
      if (source === 'swipe') {
        if (jStatus && at.total > 1) jStatus.textContent = 'Beeld ' + (at.pos + 1) + ' van ' + at.total;
      } else if (source !== 'init') {
        scrollToSlide(idx, true);
      }
    }
    // Vegen → tabje volgt. Alleen in spoormodus, niet tijdens een eigen scroll, en
    // nooit naar een Stamped-slide die nog wacht (die ligt absoluut over beeld 1).
    if (jTrack && 'IntersectionObserver' in window) {
      var jIo = new IntersectionObserver(function (entries) {
        if (!isTrack() || ownScroll) return;
        entries.forEach(function (en) {
          var pane = en.target;
          if (!en.isIntersecting || en.intersectionRatio < 0.6 || pane.classList.contains('jst-pending')) return;
          var idx = pane.getAttribute('data-jph-pane');
          var thumb = root.querySelector('[data-jph-thumb="' + idx + '"]');
          if (idx !== activeSlide && thumb && !thumb.hidden) showSlide(idx, false, 'swipe');
        });
      }, { root: jTrack, threshold: [0.6] });
      jPanes.forEach(function (pane) { jIo.observe(pane); });
    }
    // Van desktop naar mobiel (draaien, venster smaller): spoor naar het actieve beeld
    if (window.matchMedia) {
      var jMq = window.matchMedia('(max-width: 900px)');
      var jOnMode = function () { if (jMq.matches) window.requestAnimationFrame(function () { scrollToSlide(activeSlide, false); }); };
      if (jMq.addEventListener) jMq.addEventListener('change', jOnMode); else if (jMq.addListener) jMq.addListener(jOnMode);
    }
    // Een Stamped-reviewtabje dat verschijnt, telt mee in de teller
    if ('MutationObserver' in window) {
      var jMo = new MutationObserver(syncCounter);
      jThumbs.forEach(function (t) { jMo.observe(t, { attributes: true, attributeFilter: ['hidden'] }); });
    }
    showSlide(activeSlide, false, 'init');
    jThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showSlide(thumb.getAttribute('data-jph-thumb'), false); });
      thumb.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return; e.preventDefault();
        /* Golf 5d: een Stamped-reviewtabje is verborgen tot de review er staat
           (en blijft dat als er geen is) — alleen zichtbare tabjes tellen mee */
        var list = jThumbs.filter(function (t) { return !t.hidden; });
        var i = list.indexOf(thumb);
        var n = (i + dir + list.length) % list.length;
        showSlide(list[n].getAttribute('data-jph-thumb'), true);
      });
    });

    // ---- Reeks: groep-kaart (2x/4x/6x) × frequentie-toggle → plan-id ----
    var reeksPanel = root.querySelector('[data-jph-panel="reeks"]');
    if (reeksPanel) {
      var reeks = { group: null, freq: null };
      var rGroups = Array.prototype.slice.call(reeksPanel.querySelectorAll('button[data-reeks-group]'));
      var rFreqs = Array.prototype.slice.call(reeksPanel.querySelectorAll('.juizs-jph-freq-btn'));
      var rHidden = Array.prototype.slice.call(reeksPanel.querySelectorAll('input[type="radio"][data-reeks-group]'));
      if (rGroups[0]) { reeks.group = rGroups[0].getAttribute('data-reeks-group'); state.reeksCount = parseInt(rGroups[0].getAttribute('data-reeks-count'), 10) || 1; }
      if (rFreqs[0]) reeks.freq = rFreqs[0].getAttribute('data-reeks-freq');
      else if (rHidden[0]) reeks.freq = rHidden[0].getAttribute('data-reeks-freq');
      var resolveReeks = function () {
        if (!reeks.group) return;
        var chosen = null;
        rHidden.forEach(function (r) {
          if (r.getAttribute('data-reeks-group') === reeks.group && (!reeks.freq || r.getAttribute('data-reeks-freq') === reeks.freq)) chosen = r;
        });
        if (chosen) { rHidden.forEach(function (r) { r.checked = false; }); chosen.checked = true; state.planByTab.reeks = chosen.value; }
        render();
      };
      var pickRadio = function (list, btn, attr, key) {
        list.forEach(function (b) { var on = b === btn; b.classList.toggle('is-selected', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
        reeks[key] = btn.getAttribute(attr);
      };
      rGroups.forEach(function (btn) { btn.addEventListener('click', function () { pickRadio(rGroups, btn, 'data-reeks-group', 'group'); state.reeksCount = parseInt(btn.getAttribute('data-reeks-count'), 10) || 1; resolveReeks(); }); });
      rFreqs.forEach(function (btn) { btn.addEventListener('click', function () { pickRadio(rFreqs, btn, 'data-reeks-freq', 'freq'); resolveReeks(); }); });
      resolveReeks();
    }

    render();
    // C3: init-sync — details tonen direct de juiste variant
    if (state.variantId) document.dispatchEvent(new CustomEvent('juizs:variant-change', { detail: { variantId: state.variantId } }));
  }

  function initAll() { document.querySelectorAll('[data-juizs-jph]').forEach(initHero); }
  initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-juizs-jph]');
    if (root) { root.dataset.jphInit = ''; initHero(root); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juizs-reviews-expanded"] && !Shopify.designMode) return;
  try {
    
/* juizs-reviews-expanded — filters + paginering in de stand Handmatig
   (concept r2886–2960, 0723f75; golf 5f). Per sectie-instantie; alleen waar
   Liquid data-juizs-rvx zette. De tellers staan al in de knoppen (Liquid). */
(function () {
  function initRvx(root) {
    if (root.dataset.rvxInit === 'true') return;
    root.dataset.rvxInit = 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.juizs-rvx-card'));
    if (!cards.length) return;
    var perPage = parseInt(root.dataset.perPage, 10) || 4;
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-rvx-filter]'));
    var allPill = root.querySelector('[data-rvx-filter="all"]');
    var activeInfo = root.querySelector('[data-rvx-active-info]');
    var activeCount = root.querySelector('[data-rvx-active-count]');
    var clearBtn = root.querySelector('[data-rvx-clear]');
    var emptyEl = root.querySelector('[data-rvx-empty]');
    var statusEl = root.querySelector('[data-rvx-status]');
    var pagination = root.querySelector('[data-rvx-pagination]');
    var pageCurrent = root.querySelector('[data-rvx-page-current]');
    var pageTotal = root.querySelector('[data-rvx-page-total]');
    var pageMeta = root.querySelector('[data-rvx-page-meta]');
    var prevBtn = root.querySelector('[data-rvx-page="prev"]');
    var nextBtn = root.querySelector('[data-rvx-page="next"]');

    var currentFilter = 'all';
    var currentPage = 1;

    function hasTag(card, tag) {
      var tags = ' ' + (card.getAttribute('data-tags') || '').replace(/\s+/g, ' ') + ' ';
      return tags.indexOf(' ' + tag + ' ') !== -1;
    }
    function filtered() {
      return cards.filter(function (c) {
        return currentFilter === 'all' || hasTag(c, currentFilter);
      });
    }

    function render() {
      var list = filtered();
      var totalPages = Math.max(1, Math.ceil(list.length / perPage));
      if (currentPage > totalPages) currentPage = totalPages;
      if (currentPage < 1) currentPage = 1;
      var start = (currentPage - 1) * perPage;
      var visible = list.slice(start, start + perPage);

      cards.forEach(function (c) {
        c.hidden = visible.indexOf(c) === -1;
      });
      if (emptyEl) emptyEl.hidden = list.length !== 0;
      if (activeInfo) {
        activeInfo.hidden = currentFilter === 'all';
        if (activeCount) activeCount.textContent = list.length;
      }
      if (pagination) {
        pagination.hidden = list.length <= perPage;
        if (!pagination.hidden) {
          if (pageCurrent) pageCurrent.textContent = currentPage;
          if (pageTotal) pageTotal.textContent = totalPages;
          if (pageMeta) pageMeta.textContent = 'Review ' + (start + 1) + '–' + Math.min(start + perPage, list.length) + ' van ' + list.length;
          if (prevBtn) prevBtn.disabled = currentPage === 1;
          if (nextBtn) nextBtn.disabled = currentPage >= totalPages;
        }
      }
      return list.length;
    }

    function applyFilter(pill) {
      currentFilter = pill.getAttribute('data-rvx-filter');
      currentPage = 1;
      pills.forEach(function (p) {
        p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
      });
      var n = render();
      // De lijst verandert buiten de knop: meld het (één status-regio)
      if (statusEl) {
        statusEl.textContent = n + (n === 1 ? ' review' : ' reviews') +
          (currentFilter === 'all' ? '' : ' met filter ' + pill.getAttribute('data-rvx-label'));
      }
    }

    // Na bladeren gaat de focus naar de eerste nieuwe review. Blijft hij op de
    // knop en wordt die disabled (laatste pagina), dan valt hij naar <body>.
    function turnPage(delta) {
      currentPage += delta;
      render();
      var first = cards.filter(function (c) { return !c.hidden; })[0];
      if (!first) return;
      first.setAttribute('tabindex', '-1');
      first.focus({ preventScroll: true });
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      first.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () { applyFilter(p); });
    });
    // Reset verdwijnt zodra er geen filter meer actief is: focus naar 'Alle'
    if (clearBtn && allPill) {
      clearBtn.addEventListener('click', function () {
        applyFilter(allPill);
        allPill.focus();
      });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { turnPage(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { turnPage(1); });

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-juizs-rvx]').forEach(initRvx);
  }
  initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-juizs-rvx]');
    if (root) { root.dataset.rvxInit = ''; initRvx(root); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
